export const apiKey = 'api/next/';
export const apiKeyCmsSectionsDictionary = 'api/next/external-api/v3/sections';
export const defaultUrlCmsSectionsDictionary = 'external-api/v3/sections';

export const apiKeyCmsSDirectoryRecords = 'api/next/external-api/v3/directories/directory-records';
export const defaultUrlCmsDirectoryRecords = 'external-api/v3/directories/directory-records';

export const apiKeyCmsArticlesDictionary = 'api/next/external-api/v3/articles/by-sefurl';
export const defaultUrlCmsArticlesDictionary = 'external-api/v3/articles/by-sefurl';

export const apiKeyCmsArticlesAttrCode = 'api/next/external-api/v3/articles/by-attributes';
export const defaultUrlCmsArticlesAttrCode = 'external-api/v3/articles/by-attributes';

export const buildRelatedArticleUrl = (id: number, prefix?: string) => {
    return `${prefix || ''}external-api/v3/articles/${id}/related-articles`;
};
